/**
 * 商户配置钩子函数集合
 *
 * 本文件提供了一系列自定义钩子函数，用于获取和处理商户配置信息。
 * 这些钩子函数封装了从全局状态获取配置数据的逻辑，并提供了格式化和转换功能，
 * 使组件可以直接使用标准格式的配置数据，无需重复编写获取和转换逻辑。
 *
 * 主要功能：
 * 1. 获取各类配置选项列表（来源、取消原因等）
 * 2. 将配置选项转换为Select组件可用的格式
 * 3. 提供配置项查询功能
 * 4. 获取特定业务配置参数
 */

import { ConfigOptionItem } from '@/types/merchant';
import { useModel } from '@umijs/max';

// 创建选项列表
function createOptionList(list: ConfigOptionItem[]) {
  return list.map((item) => ({
    label: item.name,
    value: item.id,
  }));
}

// 获取商户配置信息
export function useMerchantConfig() {
  const { initialState } = useModel('@@initialState');
  return initialState?.merchantConfig;
}

// 获取来源列表
export function useSourceList() {
  const { initialState } = useModel('@@initialState');
  const newList = initialState?.merchantConfig?.source_options || [];
  return createOptionList(newList);
}

// 获取课程难度列表
export function useCourseDifficultyList() {
  const { initialState } = useModel('@@initialState');
  const newList = initialState?.merchantConfig?.difficulty_levels || [];
  return createOptionList(newList);
}

// 获取课程取消原因列表
export function useCourseCancelReasonList() {
  const { initialState } = useModel('@@initialState');
  const newList = initialState?.merchantConfig?.course_cancel_reasons || [];
  return createOptionList(newList);
}

// 获取结算异常原因列表
export function useSettlementAbnormalReasonList() {
  const { initialState } = useModel('@@initialState');
  const newList = initialState?.merchantConfig?.settlement_abnormal_reasons || [];
  return createOptionList(newList);
}

// 获取取消预约原因列表
export function useBookingCancelReasonList() {
  const { initialState } = useModel('@@initialState');
  const newList = initialState?.merchantConfig?.booking_cancel_reasons || [];
  return createOptionList(newList);
}
